// eslint-disable-next-line import/prefer-default-export
export const parseToIntOrNull = (value: string | null | undefined) => {
  if (!value) {
    return null;
  }

  const number = parseInt(value, 10);
  if (isNaN(number)) {
    return null;
  }
  return number;
};

export const formatCurrency = (value: number) => {
  const formatted = new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(value);

  // Move the € to the left
  return `€ ${formatted.replace("€", "").trim()}`;
};
